import axios from "./axios";

export default {
  getActiveCertificate(data) {
    const options = {
      method: "POST",
      url: "/business-certificates-mh/active",
      headers: { "content-type": "application/json" },
      data,
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  uploadCertificate(file, data) {
    const formData = new FormData();
    formData.append("file", file);
    Object.entries(data || {}).forEach(([key, value]) => {
      formData.append(key, value);
    });

    const options = {
      method: "POST",
      url: "/business-certificates-mh/upload",
      headers: { "content-type": "multipart/form-data" },
      data: formData,
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },

  deleteCertificate(data) {
    const options = {
      method: "POST",
      url: "/business-certificates-mh/delete",
      headers: { "content-type": "application/json" },
      data,
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
};
